import fontList from '../fonts/fonts';
import Tabs from 'tabs'
import Camel from 'camelcase'
import hljs from 'highlight.js';
import ClipboardJS from 'clipboard'
import Snackbar from 'snackbar';

Tabs(document.querySelector('.tab-container'));
hljs.initHighlightingOnLoad(); 

const clipboard = new ClipboardJS('.btn');
clipboard.on('success', function (e) {
    console.info('Action:', e.action)
    Snackbar.show('Code Copied 😝');
    e.clearSelection();
});


//Calculate Font Length
function renderFontLength(){
    const fontlengthHTML = `${fontList.length} Font Icons`
    const iconNumber = `${fontList.length} Icons`
    document.querySelector('#no-icons').innerHTML = iconNumber;
    
}

//Render Font Icons
function renderFontLibrary(){
     const libraryCode = fontList.map(function (font) {
        return `
            <div class="glyph-wrapper">
                <div class = "glyph">
                    <i class="z-${font.name}"></i>
                </div>
                <header contenteditable>z-${font.name} </header>
                <header contenteditable>z-${font.unicode}</header>  
            </div>
        `
     }).join('');
    document.querySelector('.glyph-container').innerHTML = libraryCode
}

//Render iOS Classes
function renderiOSCode() {
    const iosCode = fontList.map(function (font) {
        return `case ${Camel(font.name,{pascalCase: false})} = <span>"&#x</span>${font.unicode};"
`
    }).join('');
    const tempDiv = `<div>Hello</div>`
    
    document.querySelector('.ios-code').innerHTML = iosCode

}


renderFontLibrary();
renderFontLength();
renderiOSCode();

 

